import React from 'react';


function Header() {
  return (<>
    <header>
      <h4>Space Messengers</h4>
    </header>

  </>);
}

export default Header;